var map = {
	"./Amarilla.svg": "32PX",
	"./Cambio formacion.svg": "Xq0Z",
	"./Gol de penalti.svg": "C5JJ",
	"./asistencia.svg": "azDp",
	"./assist.svg": "QDUN",
	"./balon blanco lineas.svg": "nz5W",
	"./balon blanco pintado.svg": "YpYz",
	"./balon negro lineas.svg": "dGqP",
	"./balon.svg": "Snxf",
	"./doble amarilla.svg": "zAyM",
	"./doubleYellowCard.svg": "m/Y6",
	"./formationChange.svg": "KpgN",
	"./goal.svg": "ygNJ",
	"./gol en propia.svg": "RPTE",
	"./in.svg": "V7Xj",
	"./missedPenalty.svg": "PoTn",
	"./out.svg": "0rWh",
	"./ownGoal.svg": "96+h",
	"./penalty.svg": "N3MF",
	"./penaltyGoal.svg": "o741",
	"./penaltyGoal2.svg": "8O6D",
	"./redCard.svg": "+X1f",
	"./roja.svg": "zHsF",
	"./yellowCard.svg": "zxNW"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UFRR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*\.svg$
// module id = UFRR
// module chunks = 79